export const sampleUserData = [
  {
    id: 0,
    first_name: "花子",
    last_name: "佐藤",
    first_kana_name: "HANAKO",
    last_kana_name: "SATO ",
    first_furigana_name: "はなこ",
    last_furigana_name: "さとう",
    employee_number: "123456",
    email: "hanako.sato@example.com",
    secondary_email: "hanako.sato.secondary@example.com",
    is_display: true,
    personal_tel: "09023456789",
    secondary_phone_number: "08098765432",
    login_id: "hanako",
    login_password: "securePassword1!",
    tenant_department_id: "A1000",
    broadcast_group_code: "B1000",
    position_name: "開発者",
    role: 1,
    apps: ["1", "2"],
    notes: "これはサンプルのユーザーデータです。",
    delete: 0,
  },
];

export const sampleContactData = [
  {
    first_name: "花子",
    last_name: "佐藤",
    first_furigana_name: "はなこ",
    last_furigana_name: "さとう ",
    first_kana_name: "HANAKO",
    last_kana_name: "SATO",
    personal_tel: "09023456789",
    email: "hanako.sato@example.com",
    position_name: "人事部マネージャー",
    company_name: "テスト株式会社",
    company_postal_code: "100-0001",
    company_address: "東京都千代田区神田1-2-3",
    company_tel: "09023456789",
    company_fax: "03123456789",
    company_home_page: "https://www.exsample.com",
    notes: "これはサンプルの連絡先データです。",
    delete: 0,
  },
];

export const sampleDepartmentData = [
  {
    id: 1,
    name: "開発本部",
    name_kana: "かいはつほんぶ",
    display_order: "A1000",
    parent: "ABC123",
    description: "会社の開発業務を担当する部署です。",
    department_level: 1,
    delete: 0,
  },
];
